import React from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.18)',
    zIndex: 100,
    top: 0,
    left: 0,
  },
}));

interface OverlayLoadingProps {
  loading?: boolean;
}

const OverlayLoading = ({ loading = false }: OverlayLoadingProps) => {
  const classes = useStyles();
  return loading ? (
    <div className={classes.loadingContainer}>
      <CircularProgress size={60} />
    </div>
  ) : null;
};

export default OverlayLoading;
